import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchNotificacao'
})
export class SearchNotificacaoPipe implements PipeTransform {

  transform(value: any, args?: any): any {

    // console.log(value.data, args)
    if (!args) {
      return value;
    }

    const searchValue = args.toLowerCase();

    return  value.filter((val: any) => {
      const id = val.id?.toString();
      const titulo = val.titulo?.toLowerCase().toString();
      const texto = val.texto?.toLowerCase().toString();
      const dataCriacao = val.dataCriacao != "" ? this.formatarDataHora(val.dataCriacao) : val.dataCriacao;
      // const readDate = val.readDate != "" ? this.formatarDataHora(val.readDate) : val.readDate;

      return  id.includes(searchValue)||
              titulo.includes(searchValue) ||
              texto.includes(searchValue) ||
              dataCriacao.includes(searchValue)
    });

  }

  formatarDataHora(dataHora: string): string {
    const data = new Date(dataHora);// 2023-10-24T18:12:17.221Z
    const dia = data.getDate().toString().padStart(2, '0');
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    const ano = data.getFullYear();
    const hora = data.getHours().toString().padStart(2, '0');
    const minutos = data.getMinutes().toString().padStart(2, '0');

    return `${dia}/${mes}/${ano}, ${hora}:${minutos}`;
  }

}
